'use client';

export const isPWA = (() => {
  return (
    window.matchMedia('(display-mode: fullscreen)').matches ||
    // matches desktop Chrome PWA
    window.matchMedia('(display-mode: standalone)').matches
  );
})();
